import React from 'react';

const PinMap = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 22 22"
		{...props}
	>
		<g>
			<path
				d="m15.77,4c-.63-2.03-2.53-3.5-4.77-3.5s-4.14,1.47-4.77,3.5H1v17h20V4h-5.23Zm-8.81,12.01h6.86l4.98,3.99H6.97v-3.99Zm7.21-1H2v-5.03h6.08l2.92,4.02,2.89-3.98,6.11,4.8h0s0,4.86,0,4.86l-5.83-4.67Zm5.83-10.01v8.55l-5.53-4.35.52-.72h0c.64-.83,1.01-1.87,1.01-2.99,0-.17-.01-.34-.03-.5h4.03Zm-9-1.5c.51,0,.97.19,1.32.5.3.26.52.61.62,1,.04.16.06.33.06.5,0,1.1-.9,2-2,2s-2-.9-2-2c0-.17.02-.34.06-.5.1-.39.32-.74.61-1,.36-.31.82-.5,1.33-.5Zm-4.97,1.5c-.02.16-.03.33-.03.5,0,1.12.37,2.16,1,2.99h0l.35.48H2v-3.97h4.03Z"
			/>
		</g>
	</svg>
);

export default PinMap;
